<template>
  <v-row>
    <v-col>
      <v-data-table
        :headers="headers"
        :items="fpsData"
        :loading="loading"
        :items-per-page="-1"
        hide-default-footer
      >
        <template v-for="header in headers" v-slot:[`item.${header.value}`]="{ item }">
          <td :key="header.value">
            <template v-if="header.value === '_id'">
              {{ item[header.value] }}
            </template>
            <div v-else-if="item[header.value]" class="d-flex justify-space-between">
              <div class="text-center" :style="{ width: '100%' }">
                <b>{{ (item[header.value][0] || 0).toFixed(2) }}</b>
              </div>
              <div class="text-center" :style="{ width: '100%' }">
                {{ (item[header.value][1] || 0).toFixed(2) }}
              </div>
              <div class="text-center" :style="{ width: '100%' }">
                {{ (item[header.value][2] || 0).toFixed(2) }}
              </div>
            </div>
            <div v-else class="text-center" :style="{ width: '100%' }">-</div>
          </td>
        </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      fpsData: [],
      headers: [
        {
          text: 'GPU',
          align: 'left',
          filterable: false,
          value: '_id'
        },
        {
          text: 'FPS',
          align: 'center',
          sortable: false,
          value: 'FPS'
        },
        {
          text: 'FrameTime',
          align: 'center',
          sortable: false,
          value: 'FrameTime'
        },
        {
          text: 'GameThreadTime',
          align: 'center',
          sortable: false,
          value: 'GameThreadTime'
        },
        {
          text: 'RenderThreadTime',
          align: 'center',
          sortable: false,
          value: 'RenderThreadTime'
        },
        {
          text: 'RHITTime',
          align: 'center',
          sortable: false,
          value: 'RHITTime'
        },
        {
          text: 'GPUFrameTime',
          align: 'center',
          sortable: false,
          value: 'GPUFrameTime'
        }
      ]
    }
  },
  async mounted () {
    await this.getData()
  },
  watch: {
    async '$route.query' () {
      await this.getData()
    }
  },
  methods: {
    async getData () {
      if (!this.$route.query.build_id) {
        return
      }

      this.loading = true
      const { data } = await this.$axios.get(
        `${this.$store.getters.projectPath}/telemetry/hardware/fps`, {
          params: {
            build_id: this.$route.query.build_id,
            user_id: this.$route.query.user_id
          }
        }
      ).catch(error => ({ data: { err: true, message: error.response.data } }))

      if (data.err) {
        this.$toasted.error(data.message)
      } else {
        this.fpsData = data
      }
      this.loading = false
    }
  }
}
</script>